import { render, staticRenderFns } from "./NotasNivel2.vue?vue&type=template&id=d360f57e&lang=html"
import script from "./NotasNivel2.vue?vue&type=script&lang=js"
export * from "./NotasNivel2.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel2.vue?vue&type=style&index=0&id=d360f57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports